import React, { useEffect, useState } from "react";
import aboutUAICLayout from "../../assets/img/aboutus/aboutUAICLayout.svg";
import { Container, Row, Col, Image, Card, Badge } from "react-bootstrap";
import "./AboutUsUAIC.css";

const AboutUsUAIC = () => {
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <>
      <div style={{ ...styles.container, margin: "0 auto" }}>
        {/* <Container> */}
        <Row
          style={{
            position: "relative",
            left: 0,
          }}
        >
          {/* Left Column: Text Content */}
          <Col lg={6} className="position-relative mt-5 mt-lg-0 text-left ">
            {/* Circular Image */}
            <div className="uaic -image-wrapper mx-auto">
              <Image
                src={require("../../assets/img/aboutus/aboutUAICLeft.svg")}
                roundedCircle
                fluid
                className="aboutRightImage"
                alt="aboutRightImage"
              />
            </div>
          </Col>

          {/* Right Column: Image + Floating Cards */}
          <Col lg={6}>
            <p
              style={{
                color: "#17252E",
                fontSize: "15px",
                lineHeight: "140%",
                fontWeight: 600,
                whiteSpace: "nowrap",
                position: "relative", // required for ::after
                display: "inline-block",
              }}
            >
              <span
                style={{
                  position: "relative",
                  paddingBottom: "5px",
                }}
              >
                About Us
                <span
                  style={{
                    content: '""',
                    position: "absolute",
                    left: 0,
                    bottom: -4,
                    height: "1.6px",
                    width: "140%", // Extend beyond text
                    backgroundColor: "#0e72d6",
                    transform: "translateX(0%)", // Centered extension
                  }}
                />
              </span>
            </p>

            <h1
              className="mt-2"
              style={{
                color: "#000",
                lineHeight: "100%",
                fontWeight: responsiveStatus ? 600 : 500,
                fontSize: responsiveStatus ? "20px" : "32px",
              }}
            >
              United Automobile Insurance Company (UAIC)
            </h1>

            <p className="mb-4 text-secondary">
              UAIC, one of the largest privately held property and casualty
              insurers in the U.S., began in Florida and Illinois and has
              expanded to multiple states. This family-owned company provides
              high-quality, low-cost automobile insurance, driven by disciplined
              underwriting, strategic claims handling, and exceptional service.
            </p>
            <p className="mb-4 text-secondary">
              UAIC’s user-friendly, reliable web technology supports its
              operations and has been instrumental in its success. Trusted by
              independent agents and customers, UAIC has become a market leader
              in every state it operates, maintaining a commitment to innovation
              and delivering superior insurance solutions.
            </p>
          </Col>
        </Row>
        {/* </Container> */}
      </div>
    </>
  );
};

const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
    backgroundImage: `url(${aboutUAICLayout})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    maxWidth: "1350px",
    margin: "0 auto",
  },
  container1: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    minHeight: "400px",
    fontFamily: "Arial, sans-serif",
  },
};

export default AboutUsUAIC;
